export default __webpack_public_path__ + "static/media/tailwind_zospace.3817c3e7.svg";